module.exports = {
    "isAnimation": true,
    "isLoop": true,
    "frames": [
        {
            "time": 0,
            "image": require("./jasmine_idle_0000.png").default
        },
        {
            "time": 500,
            "image": require("./jasmine_idle_0500.png").default
        },
        {
            "time": 700,
            "image": require("./jasmine_idle_0700.png").default
        },
        {
            "time": 900,
            "image": require("./jasmine_idle_0900.png").default
        },
        {
            "time": 1100,
            "image": require("./jasmine_idle_1100.png").default
        },
    ]
}
